import isEmpty from "./is-Empty";

export default function TimestampConverter(str, displayDate = false) {
  const date = new Date(str);

  if (displayDate) {
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    if (!isEmpty(str)) {
      return date.toLocaleDateString("en-US", options);
    } else {
      return str;
    }
  } else {
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    if (!isEmpty(str)) {
      return date.toLocaleDateString("en-US", options);
    } else {
      return str;
    }
  }
}

export const formatTimer = (seconds) => {
  const m = String(Math.floor(seconds / 60)).padStart(2, "0");
  const s = String(seconds % 60).padStart(2, "0");
  return `${m}:${s}`;
};
